import React from 'react';
import PropTypes from 'prop-types';
import Image from './Image';

const SvgImage = (props) => {
    return (<Image
        autoScale={props.autoScale}
        contentId={props.originSrc}
        isInteraction={props.isInteraction}
        isPreRender={props.isPreRender}
        model={props.model}
        reportReady={props.reportReady}
        src={props.content}
        useModelWidthAndHeight={props.useModelWidthAndHeight}
    />);
};

SvgImage.propTypes = {
    autoScale: PropTypes.bool,
    content: PropTypes.string.isRequired,
    isInteraction: PropTypes.bool.isRequired,
    isPreRender: PropTypes.bool,
    model: PropTypes.object.isRequired,
    originSrc: PropTypes.string.isRequired,
    reportReady: PropTypes.func,
    useModelWidthAndHeight: PropTypes.bool,
};

export default SvgImage;
